import {
  ReactElement,
  ChangeEvent,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

import { DialogConfirmDeleteScheduleRouteProps } from './types';
import DialogConfimation from '../DialogConfimation';

const initialDeleteRelatedRoutes = false;

const warningText = `Esta acción eliminará de forma permanente la agenda.
  Las rutas programadas relacionadas por realizar serán eliminadas en caso de
  seleccionar la siguiente casilla`;

const DialogConfirmDeleteScheduleRoute = ({
  open,
  onConfirm,
  onCancel,
  loadingConfirm = false,
  scheduleCode,
}: DialogConfirmDeleteScheduleRouteProps): ReactElement => {
  const description = useMemo(
    () => `La agenda #${scheduleCode} será eliminada`,
    [scheduleCode],
  );

  const [deleteRelatedRoutes, setDeleteRelatedRoutes] = useState(
    initialDeleteRelatedRoutes,
  );

  const handleChangeDeleteRelatedRoutes = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setDeleteRelatedRoutes(event.target.checked);
    },
    [],
  );

  const handleConfirm = useCallback(() => {
    onConfirm(deleteRelatedRoutes);
  }, [onConfirm, deleteRelatedRoutes]);

  useEffect(() => {
    if (!open) {
      setDeleteRelatedRoutes(initialDeleteRelatedRoutes);
    }
  }, [open]);

  return (
    <DialogConfimation
      open={open}
      description={description}
      warningText={warningText}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      loadingConfirm={loadingConfirm}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={deleteRelatedRoutes}
            onChange={handleChangeDeleteRelatedRoutes}
            size="small"
          />
        }
        label="Eliminar rutas programadas relacionadas"
      />
    </DialogConfimation>
  );
};

export default DialogConfirmDeleteScheduleRoute;
